export enum WorkPlaceTableColumn {
  CAMPUS = 'Campus',
  PROGRAMA = 'Programa',
  CCT = 'Nombre',
  ESTATUS = 'Estatus',
}
